import { useEffect, useState } from 'react';
import { Badge, OfficialBadge } from './types';
import { CommonDependency } from '@/dependency';

export const useAllBadgeList = () => {
  const [data, setData] = useState<{ badge_list: Badge[]; officialBadge_list: OfficialBadge[] }>();
  useEffect(() => {
    Promise.all([
      CommonDependency.api.getBadgeList().then(res => ({ badge_list: res?.badge_list })),
      CommonDependency.api
        .getOfficialBadgeList()
        .then(res => ({ officialBadge_list: res?.badge_list })),
    ])
      .then(res => {
        const data = res.reduce((prv, cur) => {
          return { ...cur, ...prv };
        }, []);
        setData(data);
      })
      .catch(() => []);
  }, []);
  return { data };
};
